import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { YoutubeVideo } from '@rotaryintl/harris-video';

const MyYoutubeVideo = ({ sitecoreContext, fields: { YoutubeId, Title, Type, Format } = {} }) => (
  <YoutubeVideo youtubeId={YoutubeId?.value} filename={Title?.value} type={Type?.fields?.Value?.value || ''} format={Format?.fields?.Value?.value || ''} />
);
export default withSitecoreContext()(MyYoutubeVideo);
